<script>
    // import validator from 'validator';
    import {HeroForm} from '../store.js';
    import {getContext} from 'svelte';
    import Autocomplete from '../component/autocomplete.svelte';
    import {getCountry, getCity, getPhone} from '../utils';
    let code;
    let saveCity;
    let saveCityPlaceHolder;
    let CountryNamePlaceHolder;
    let CountryName;
    let saveCode;
    let CountryCodePlaceHolder;
    let changeClr = 'clr';
    let changeClrMob = 'select-mobile';
    const formData = {
        name: '',
        email: '',
        country: '',
        countryCode: '',
        city: '',
        phoneNumber: '',
        dateOfBirth: '',
        gender: '',
    };
    const DOB = {
        MDOB: '',
        DDOB: '',
        YDOB: '',
    };
    const genderOptions = [
        'Male',
        'Female',
        'Other',
    ];
    const {url} = getContext('APP');
    const formNo = Object.fromEntries(new URLSearchParams($url.search));
    if (HeroForm.get() != undefined) {
        formData.name = HeroForm.get().name;
        formData.email = HeroForm.get().email;
        formData.country = HeroForm.get().country;
        formData.countryCode = HeroForm.get().countryCode;
        formData.city = HeroForm.get().city;
        formData.phoneNumber = HeroForm.get().phoneNumber;
        formData.gender = HeroForm.get().gender;
        formData.dateOfBirth = HeroForm.get().dateOfBirth;
        const arr = formData.dateOfBirth.split('-');
        DOB.MDOB = arr[0];
        DOB.DDOB = arr[1];
        DOB.YDOB = arr[2];
    }
    $: if (HeroForm.get() != undefined) {
        formData.dateOfBirth = DOB.MDOB+'-'+DOB.DDOB+'-'+DOB.YDOB;
        HeroForm.update((n)=> n={session: HeroForm.get().session, name: formData.name, email: formData.email,
            country: formData.country,
            countryCode: formData.countryCode, city: formData.city, phoneNumber: formData.phoneNumber,
            dateOfBirth: formData.dateOfBirth, gender: formData.gender,
            technicalSkill: HeroForm.get().technicalSkill, englishAbility: HeroForm.get().englishAbility,
            industry: HeroForm.get().industry, industryOther: HeroForm.get().industryOther,
            business: HeroForm.get().business, visa: HeroForm.get().visa,
            aid: HeroForm.get().aid, referalName: HeroForm.get().referalName,
            hearAbout: HeroForm.get().hearAbout, hearAboutOthers: HeroForm.get().hearAboutOthers,
            startup: HeroForm.get().startup,
            aboutYourSelf: HeroForm.get().aboutYourSelf,
            portfolioURL: HeroForm.get().portfolioURL, buildingPlan: HeroForm.get().buildingPlan,
            travelBudget: HeroForm.get().travelBudget, buildingWeeks: HeroForm.get().buildingWeeks,
            invitedtoProgram: HeroForm.get().invitedtoProgram, ackowledged: HeroForm.get().ackowledged});
    }
    /**
     *
     *
     */
    function updateval() {
        HeroForm.update((n)=> n={session: HeroForm.get().session, name: formData.name, email: formData.email,
            country: formData.country,
            countryCode: formData.countryCode, city: formData.city, phoneNumber: formData.phoneNumber,
            dateOfBirth: formData.dateOfBirth, gender: formData.gender,
            technicalSkill: HeroForm.get().technicalSkill, englishAbility: HeroForm.get().englishAbility,
            industry: HeroForm.get().industry, industryOther: HeroForm.get().industryOther,
            business: HeroForm.get().business, visa: HeroForm.get().visa,
            aid: HeroForm.get().aid, referalName: HeroForm.get().referalName,
            hearAbout: HeroForm.get().hearAbout, hearAboutOthers: HeroForm.get().hearAboutOthers,
            startup: HeroForm.get().startup,
            aboutYourSelf: HeroForm.get().aboutYourSelf,
            portfolioURL: HeroForm.get().portfolioURL, buildingPlan: HeroForm.get().buildingPlan,
            travelBudget: HeroForm.get().travelBudget, buildingWeeks: HeroForm.get().buildingWeeks,
            invitedtoProgram: HeroForm.get().invitedtoProgram, ackowledged: HeroForm.get().ackowledged});
    }
    /**
     *
     * @param {string}object
     */
    function SaveData() {
        // if ( validator.isEmail(formData.email) === true) {
        if (formNo.name === 'HeroTraining') {
            location.href='/apply?name=HeroTraining&FormNo=thirdform';
        } else if (formNo.name === 'KanooInnovationHub') {
            location.href='/apply?name=KanooInnovationHub&FormNo=thirdform';
        } else if (formNo.name === 'HouseOfCeek') {
            location.href='/apply?name=HouseOfCeek&FormNo=thirdform';
        } else if (formNo.FormNo === 'secondform' && formNo.name === 'FundamentalsOfEntrepreneurship') {
            location.href='/apply?name=FundamentalsOfEntrepreneurship&FormNo=thirdform';
        } else if (formNo.FormNo === 'secondform' && formNo.name === 'CorporateInnovation') {
            location.href='/apply?name=CorporateInnovation&FormNo=thirdform';
        } else if (formNo.FormNo === 'secondform' && formNo.name === 'Blockchain') {
            location.href='/apply?name=Blockchain&FormNo=thirdform';
        } else if (formNo.FormNo === 'secondform' && formNo.name === 'CorporateAccelerator') {
            location.href='/apply?name=CorporateAccelerator&FormNo=thirdform';
        }
        // } else {
        //     emailError.style.display = 'block';
        //     emailErrorMob.style.display = 'block';
        // }
    }
    /**
     *
     *
     */
    function goBack() {
        if (formNo.name === 'FundamentalsOfEntrepreneurship') {
            location.href='/apply?name=FundamentalsOfEntrepreneurship&FormNo=firstform';
        } else if (formNo.name === 'CorporateInnovation') {
            location.href='/apply?name=CorporateInnovation&FormNo=firstform';
        } else if (formNo.name === 'Blockchain') {
            location.href='/apply?name=Blockchain&FormNo=firstform';
        } else if (formNo.name === 'CorporateAccelerator') {
            location.href='/apply?name=CorporateAccelerator&FormNo=firstform';
        } else if (formNo.name ==='HeroTraining') {
            location.href='/apply?name=HeroTraining&FormNo=firstform';
        } else if (formNo.name === 'KanooInnovationHub') {
            location.href='/apply?name=KanooInnovationHub&FormNo=firstform';
        } else if (formNo.name === 'HouseOfCeek') {
            location.href='/apply?name=HouseOfCeek&FormNo=firstform';
        }
    }
    $: if ((saveCity != undefined) && (saveCity != '')) {
        formData.city = saveCity;
        updateval();
    }
    $: if ((CountryName != undefined) && (CountryName != '') && (code != CountryName)) {
        formData.country = CountryName;
        updateval();
    }
    $: if ((saveCode != undefined) && (saveCode != '')) {
        formData.countryCode = saveCode;
        updateval();
    }
    $: if (formData.city != '') {
        saveCityPlaceHolder = formData.city;
    }
    $: if (formData.country != '') {
        CountryNamePlaceHolder= formData.country;
    }
    $: if (formData.countryCode != '') {
        CountryCodePlaceHolder = formData.countryCode;
    }
    $: if (formData.gender != '') {
        changeClr = 'chclr';
        changeClrMob = 'select-mobile-ch';
    }
    // <!-- Google Tag Manager -->
(function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <div class="desktop">
        <div class="back-arrow" on:click={() => ( goBack())}>
            <img src="images/apply/back_arrow.svg" alt="">
        </div>
        <form on:submit|preventDefault={SaveData}>
            <div>
                <div style="display:flex;">
                    <div style="margin-left: 4.96vw;">
                        <label for="f_name">Your Full Name</label>
                        <div>
                            <input
                                required
                                type="text"
                                id="f_name"
                                placeholder="Olive Yew"
                                style="width: 18.915vw;margin-top: 0.397vw;"
                                bind:value={formData.name}
                            />
                        </div>
                    </div>

                    <div style="margin-left: 2.646vw;">
                        <label for="email">E-Mail</label>
                        <div>
                            <input
                                required
                                style="width: 25.132vw;margin-top: 0.397vw;"
                                type="email"
                                id="email"
                                placeholder="example@domain.com"
                                bind:value={formData.email}
                            />
                        </div>
                    </div>
                </div>
                <div style="display:flex;">
                    <div style="margin-left: 4.96vw;">
                        <label for="country">Country</label>
                        <div style="margin-top: 0.397vw;">
                            <Autocomplete 
                                id="ac-location"
                                placeholder={CountryNamePlaceHolder}
                                searchFunction={getCountry}
                                bind:value={CountryName}
                                bind:valueName={code}
                            />
                        </div>
                    </div>

                    <div style="margin-left: 2.646vw;">
                        <label for="country_code">Country Code</label>
                        <div style="margin-top: 0.397vw;">
                            <Autocomplete 
                                id="ac-location"
                                placeholder={CountryCodePlaceHolder}
                                searchFunction={getPhone}
                                bind:value={saveCode}
                            />
                            <!-- <input placeholder={formData.countryCode} readonly> -->
                        </div>
                    </div>

                    <div style="margin-left: 2.646vw;">
                        <label for="country">City</label>
                            <div style="margin-top: 0.397vw;">
                                <Autocomplete
                                    id="ac-location-city"
                                    placeholder={saveCityPlaceHolder}
                                    searchFunction={(e)=>getCity(code, e)}
                                    bind:value={saveCity}
                            />
                        </div>
                    </div>
                </div>

                <div style="display:flex;">
                    <div style="margin-left: 4.96vw;">
                        <label for="Pno">Phone Number</label>

                        <div>
                            <input
                                required
                                type="number"
                                id="Pno"
                                placeholder="xxxxxxxxxxx"
                                style="width: 18.915vw;margin-top: 0.397vw;"
                                bind:value={formData.phoneNumber}
                            />
                        </div>
                    </div>

                    <div style="margin-left: 2.646vw;">
                        <label for="DOB">Date of Birth</label>

                        <div>
                            <input
                                required
                                style="width: 6.415vw;margin-top: 0.397vw;"
                                type="number"
                                id="DOB"
                                placeholder="MM"
                                bind:value={DOB.MDOB}
                            />
                            <input
                                required
                                style="margin-left:1.323vw; width: 6.415vw;margin-top: 0.397vw;"
                                type="number"
                                id="DOB"
                                placeholder="DD"
                                bind:value={DOB.DDOB}
                            />
                            <input
                                required
                                style="margin-left:1.323vw; width: 8.267vw;margin-top: 0.397vw;"
                                type="number"
                                id="DOB"
                                placeholder="YY"
                                bind:value={DOB.YDOB}                               
                            />
                        </div>
                    </div>
                    <div style="margin-left: 3vw;">
                        <label for="gender">Gender</label>
                        <div>
                            <select
                                class = {changeClr}                               
                                bind:value={formData.gender}
                                required
                            >
                            <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                                {#each genderOptions as option}
                                    <option value={option}>
                                        {option}
                                    </option>
                                {/each}                               
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-left: 5vw; margin-top: 5vw;">
                <button
                    style=" background-color: rgba(60, 116, 192, 1);
                            border-radius: 1.984vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 1.190vw;"
                    >Next</button
                >
            </div>
        </form>
    </div>
    <div class="mobile">
        <form on:submit|preventDefault={SaveData}>
            <div>
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">Your Full Name</p>
    
                    <div>
                        <input
                            required
                            style="width: 50.0vw;"
                            class="input-mobile"
                            type="text"
                            id="f_name"
                            placeholder="Olive Yew"
                            bind:value={formData.name}
                        />
                    </div>
                </div>
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">E-Mail</p>
    
                    <div>
                        <input
                            required
                            class="input-mobile"
                            style="width: 71.0vw;"
                            type="email"
                            id="email"
                            placeholder="example@domain.com"
                            bind:value={formData.email}
                        />
                    </div>
                </div>
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">Country</p>
                    <div>
                        <Autocomplete 
                            id="ac-location"
                            placeholder={CountryNamePlaceHolder}
                            searchFunction={getCountry}
                            bind:value={CountryName}
                            bind:valueName={code}
                        />
                    </div>
                </div>
    
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">CountryCode</p>
                    <div>
                        <Autocomplete 
                            id="ac-location"
                            placeholder={CountryCodePlaceHolder}
                            searchFunction={getPhone}
                            bind:value={saveCode}
                        />
                    </div>
                </div>
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">City</p>
                        <Autocomplete
                            id="ac-location-city"
                            placeholder={saveCityPlaceHolder}
                            searchFunction={(e)=>getCity(code, e)}
                            bind:value={saveCity}
                        />
                </div>
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">Phone Number</p>
    
                    <div>
                        <input
                            required
                            class="input-mobile"
                            style="width: 50.0vw;"
                            type="text"
                            id="Pno"
                            placeholder="xxxxxxxxxxx"
                            bind:value={formData.phoneNumber}
                        />
                    </div>
                </div>
    
                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">Date of Birth</p>
    
                    <div>
                        <input
                            required
                            style="width: 19.647vw;"
                            class="input-mobile"
                            type="number"
                            id="DOB"
                            placeholder="MM"
                            bind:value={DOB.MDOB}
                        />
                        <input
                            required
                            style="width: 19.647vw;"
                            class="input-mobile"
                            type="number"
                            id="DOB"
                            placeholder="DD"
                            bind:value={DOB.DDOB}
                        />
                        <input
                            required
                            style="width: 25.319vw;"
                            class="input-mobile"
                            type="number"
                            id="DOB"
                            placeholder="YY"
                            bind:value={DOB.YDOB}    
                        />
                    </div>
                </div>


                <div style="margin-left: 8.333vw;">
                    <p class="p-mobile">Gender</p>
    
                    <div>
                        <select
                            style="width: 50.0vw;"
                            class = {changeClrMob}                               
                            bind:value={formData.gender}
                            required
                        >
                        <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                            {#each genderOptions as option}
                                <option value={option}>
                                    {option}
                                </option>
                            {/each}                               
                        </select>
                    </div>
                </div>

            </div> 
            <div style="margin-left: 8vw; margin-top: 5vw; display: flex; gap: 4.673vw;">
                <button
                    style=" background-color: rgba(60, 116, 192, 1);
                            border-radius: 6.069vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 3.889vw;"
                   >Next</button>
                   <div class="back-arrow-mob" on:click={() => ( goBack())}>
                        <img src="images/apply/back_button.svg" alt="">
                   </div>
            </div>      
        </form>   
    </div>
</section>

<style>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type=number]{
        -moz-appearance: textfield;
    }
    .clr{
        width: 18.915vw; 
        color: rgba(171, 171, 171, 1);
        margin-top: 0.397vw;
    }
    .chclr{
        width: 18.915vw; 
        color:  black;
        margin-top: 0.397vw;
    }
    option{
        color:  black;
    }
    .back-arrow{
        width: 1.72vw;
        height: 0.926vw;
        margin-left: 2.646vw;
        margin-bottom: -1vw;
        margin-top: 1.323vw;
        cursor: pointer;
    }
    .back-arrow img{
        width: 100%;
        height: 100%;
    }
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("images/dropdown.svg");
        background-repeat: no-repeat;
        background-position-x: 17.4vw;
        background-position-y: 1vw;
        background-size: 0.6vw;
    }
    input {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        font-size: 0.926vw;
    }
    input::placeholder {
        font-size: 0.926vw;
    }
    label {
        font-size: 1.058vw;
        margin-top: 1.984vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 700;
    }
    select {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        background-color: transparent;
        font-size: 0.926vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .back-arrow-mob{
            width: 10.047vw;
            height: 7.243vw;
        }
        .back-arrow-mob img{
            width: 100%;
            height: 100%;
        }
        input {
            border: 0.556vw solid rgba(171, 171, 171, 1);
            border-radius: 1.661vw;
            padding-left: 5.5vw;
            font-size: 3.187vw;
        }
        input::placeholder {
            font-size: 3.187vw;
        }
        select {
            font-size: 3.187vw;
        }
        .input-mobile {
            border: 0.556vw solid rgba(171, 171, 171, 1);
            border-radius: 1.661vw;
            padding-left: 5.5vw;
            height: 9.111vw;
        }
        .p-mobile {
            font-size: 3.187vw;
            margin-top: 6.667vw;
            color: rgba(0, 32, 75, 1);
            font-weight: 700;
        }
        select {
            background-position-x: 43.3vw;
            background-position-y: 3vw;
            background-size: 3.7vw;
        }
        .select-mobile {
            appearance: none;
            background-image: url(images/dropdown.svg);
            background-repeat: no-repeat;
            background-position-x: 43.3vw;
            background-position-y: 3vw;
            background-size: 3.7vw;
        }
        .select-mobile {
            border: 0.556vw solid rgba(171, 171, 171, 1);
            border-radius: 1.661vw;
            padding-left: 5.5vw;
            height: 9.111vw;
            background-color: transparent;
            color: rgba(171, 171, 171, 1);
        }
        .select-mobile-ch {
            border: 0.556vw solid rgba(171, 171, 171, 1);
            border-radius: 1.661vw;
            padding-left: 5.5vw;
            height: 9.111vw;
            background-color: transparent;
            color: black;
        }
    }
</style>
